function parseTs(v) {
  if (v == null || v === '') return 0
  const num = typeof v === 'number' ? v : parseInt(String(v), 10)
  return Number.isFinite(num) ? num : 0
}

/** Oldest first: slot 0 = first-created banner for that type, slot 1 = second, etc. */
export function sortBannerRowsByListSlot(rows) {
  if (!rows?.length) return []
  return [...rows].sort((a, b) => {
    const ca = parseTs(a?.createdAt)
    const cb = parseTs(b?.createdAt)
    if (ca !== cb) return ca - cb
    const ida = String(a?.id ?? '')
    const idb = String(b?.id ?? '')
    return ida.localeCompare(idb)
  })
}

export function pickBannerRowForSlot(rows, slotIndex) {
  const sorted = sortBannerRowsByListSlot(rows)
  if (
    typeof slotIndex !== 'number' ||
    slotIndex < 0 ||
    slotIndex >= sorted.length
  ) {
    return undefined
  }
  return sorted[slotIndex]
}
